import React from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import Button from "../Button";
import FruitIcon from "../FruitIcon";
import Bowl from "../../imageComponents/fruits/default/bowl";
import BowlSwooshes from "../../imageComponents/fruits/swooshes/bowl_swooshes";
import Corn from "../../imageComponents/fruits/default/corn";
import CornSwooshes from "../../imageComponents/fruits/swooshes/corn_swooshes";
import Avocado from "../../imageComponents/fruits/default/avocado";
import Melon from "../../imageComponents/fruits/default/melon";
import Logo from "../../imageComponents/logo";

const CtaComponent = () => {
  const { t } = useTranslation();
  return (
    <div className="cta-component layout desktop:container-desktop mobile:container-mobile tablet:container-mobile">
      <div className="content">
        <div className="logo-wrapper">
          <Logo />
        </div>
        <div className="text desktop:desktop-h1 mobile:mobile-h1 tablet:mobile-h1">
          {t("ctaInfoPart1")}
          <span>{t("ctaInfoPart2")}</span>
          {t("ctaInfoPart3")}
        </div>
        <Button variant={3} text={t("ctaButtonText")} />
      </div>
      <FruitIcon
        withSwoosh={true}
        className="bowl-image fruits"
        Icon={Bowl}
        Swoosh={BowlSwooshes}
      />
      <FruitIcon
        withSwoosh={true}
        className="corn-image fruits"
        Icon={Corn}
        Swoosh={CornSwooshes}
      />
      <FruitIcon
        withSwoosh={false}
        className="melon-image fruits"
        Icon={Melon}
      />
      <FruitIcon
        withSwoosh={false}
        className="avocado-image fruits"
        Icon={Avocado}
      />
    </div>
  );
};

export default CtaComponent;
